const BGContainerAdapter = ({ block, data, id, onChangeBlock, value }) => {
  onChangeBlock(block, {
    ...data,
    [id]: value,
  });
};

export default BGContainerAdapter;
